import app from "flarum/forum/app";
import { extend } from "flarum/common/extend";
import IndexPage from "flarum/forum/components/IndexPage";
import IndexSidebar from "flarum/forum/components/IndexSidebar";
import HeaderSecondary from "flarum/forum/components/HeaderSecondary";
import DiscussionPage from "flarum/forum/components/DiscussionPage";
import listItems from "flarum/common/helpers/listItems";
import Navigation from "flarum/common/components/Navigation";
import styleDiscussionList from "./styleDiscussionList";
import XgayHeaderLogo from "./components/XgayHeaderLogo";
import registerSignupTracking from "./trackRegistration";
app.initializers.add('xgay-core-signup-tracking', registerSignupTracking);
const navigationKeys = ["allDiscussions", "following", "tags"];
class MobileTags extends IndexSidebar {
  view() {
    const tags = this.navItems().toArray().filter(item => /^tag\d+$/.test(item.itemName) || item.itemName === "moreTags");
    if (!tags.length) return null;
    return m("nav", {
      className: "XgayMobileTags",
      "aria-label": app.translator.trans("flarum-tags.forum.index.tags_link")
    }, m("ul", null, listItems(tags)));
  }
}
app.initializers.add("xgay-core-navigation", () => {
  styleDiscussionList();
  extend(HeaderSecondary.prototype, "items", function (items) {
    // Rebuild from the current core/extension navigation so auth and SPA state stay current.
    const sidebar = new IndexSidebar();
    sidebar.attrs = {};
    const navigation = sidebar.navItems();
    const keys = navigationKeys.filter(key => navigation.has(key));
    const anchor = items.has("flags") ? items.getPriority("flags") : 15;
    const lowerPriorities = items.toArray().map(item => items.getPriority(item.itemName)).filter(priority => priority < anchor);
    const next = lowerPriorities.length ? Math.max(...lowerPriorities) : anchor - 1;
    keys.forEach((key, index) => {
      const content = navigation.get(key);
      if (!content || typeof content !== "object" || !("tag" in content)) return;
      const vnode = content;
      items.add(key, {
        ...vnode,
        attrs: {
          ...vnode.attrs,
          itemClassName: "XgayMobileNav"
        }
      }, anchor - (anchor - next) * (index + 1) / (keys.length + 1));
    });
  });
  extend(IndexPage.prototype, "contentItems", function (items) {
    // Banner: 110; tags: 105; toolbar: 100; discussion list: 90.
    items.add("xgay-mobile-tags", MobileTags.component(), 105);
  });
  extend(DiscussionPage.prototype, "sidebarItems", function (items) {
    // Banner: 110; tags: 105; toolbar: 100; discussion list: 90.
    if (items.has("scrubber")) items.remove("scrubber");
  });
  extend(Navigation.prototype, "items", function (items) {
    if (items.has("drawer")) {
      items.add("xgay-header-logo", XgayHeaderLogo.component());
    }
  });
}, -100);